// extracted by mini-css-extract-plugin
export default {"page":"RecoWork_page__4LML4","page_container":"RecoWork_page_container__hL0nF","reco_banner":"RecoWork_reco_banner__3UZsb","loading":"RecoWork_loading__iq2ZJ"};